/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BidsRouteImport } from './routes/bids'
import { Route as CompareRouteImport } from './routes/compare'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as LoginRouteImport } from './routes/login'
import { Route as NotificationsRouteImport } from './routes/notifications'
import { Route as PaymentsRouteImport } from './routes/payments'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ShippingRouteImport } from './routes/shipping'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as WatchlistRouteImport } from './routes/watchlist'
import { Route as AuctionsIndexRouteImport } from './routes/auctions.index'
import { Route as AuctionsVehicleIdRouteImport } from './routes/auctions.$vehicleId'
import { Route as VehiclesIndexRouteImport } from './routes/vehicles/index'
import { Route as VehiclesVehicleIdRouteImport } from './routes/vehicles/$vehicleId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const BidsRoute = BidsRouteImport.update({
  id: '/bids',
  path: '/bids',
  getParentRoute: () => rootRouteImport,
} as any)
const CompareRoute = CompareRouteImport.update({
  id: '/compare',
  path: '/compare',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const HowItWorksRoute = HowItWorksRouteImport.update({
  id: '/how-it-works',
  path: '/how-it-works',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const NotificationsRoute = NotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsRoute = PaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ShippingRoute = ShippingRouteImport.update({
  id: '/shipping',
  path: '/shipping',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const WatchlistRoute = WatchlistRouteImport.update({
  id: '/watchlist',
  path: '/watchlist',
  getParentRoute: () => rootRouteImport,
} as any)
const AuctionsIndexRoute = AuctionsIndexRouteImport.update({
  id: '/auctions/',
  path: '/auctions/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuctionsVehicleIdRoute = AuctionsVehicleIdRouteImport.update({
  id: '/auctions/$vehicleId',
  path: '/auctions/$vehicleId',
  getParentRoute: () => rootRouteImport,
} as any)
const VehiclesIndexRoute = VehiclesIndexRouteImport.update({
  id: '/vehicles/',
  path: '/vehicles/',
  getParentRoute: () => rootRouteImport,
} as any)
const VehiclesVehicleIdRoute = VehiclesVehicleIdRouteImport.update({
  id: '/vehicles/$vehicleId',
  path: '/vehicles/$vehicleId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/bids': typeof BidsRoute
  '/compare': typeof CompareRoute
  '/contact': typeof ContactRoute
  '/dashboard': typeof DashboardRoute
  '/faq': typeof FaqRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/how-it-works': typeof HowItWorksRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/payments': typeof PaymentsRoute
  '/pricing': typeof PricingRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/shipping': typeof ShippingRoute
  '/verify-email': typeof VerifyEmailRoute
  '/watchlist': typeof WatchlistRoute
  '/auctions/$vehicleId': typeof AuctionsVehicleIdRoute
  '/vehicles/$vehicleId': typeof VehiclesVehicleIdRoute
  '/auctions/': typeof AuctionsIndexRoute
  '/vehicles/': typeof VehiclesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/bids': typeof BidsRoute
  '/compare': typeof CompareRoute
  '/contact': typeof ContactRoute
  '/dashboard': typeof DashboardRoute
  '/faq': typeof FaqRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/how-it-works': typeof HowItWorksRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/payments': typeof PaymentsRoute
  '/pricing': typeof PricingRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/shipping': typeof ShippingRoute
  '/verify-email': typeof VerifyEmailRoute
  '/watchlist': typeof WatchlistRoute
  '/auctions/$vehicleId': typeof AuctionsVehicleIdRoute
  '/vehicles/$vehicleId': typeof VehiclesVehicleIdRoute
  '/auctions': typeof AuctionsIndexRoute
  '/vehicles': typeof VehiclesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/bids': typeof BidsRoute
  '/compare': typeof CompareRoute
  '/contact': typeof ContactRoute
  '/dashboard': typeof DashboardRoute
  '/faq': typeof FaqRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/how-it-works': typeof HowItWorksRoute
  '/login': typeof LoginRoute
  '/notifications': typeof NotificationsRoute
  '/payments': typeof PaymentsRoute
  '/pricing': typeof PricingRoute
  '/profile': typeof ProfileRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/shipping': typeof ShippingRoute
  '/verify-email': typeof VerifyEmailRoute
  '/watchlist': typeof WatchlistRoute
  '/auctions/$vehicleId': typeof AuctionsVehicleIdRoute
  '/vehicles/$vehicleId': typeof VehiclesVehicleIdRoute
  '/auctions/': typeof AuctionsIndexRoute
  '/vehicles/': typeof VehiclesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/bids'
    | '/compare'
    | '/contact'
    | '/dashboard'
    | '/faq'
    | '/forgot-password'
    | '/how-it-works'
    | '/login'
    | '/notifications'
    | '/payments'
    | '/pricing'
    | '/profile'
    | '/register'
    | '/reset-password'
    | '/shipping'
    | '/verify-email'
    | '/watchlist'
    | '/auctions/$vehicleId'
    | '/vehicles/$vehicleId'
    | '/auctions/'
    | '/vehicles/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/bids'
    | '/compare'
    | '/contact'
    | '/dashboard'
    | '/faq'
    | '/forgot-password'
    | '/how-it-works'
    | '/login'
    | '/notifications'
    | '/payments'
    | '/pricing'
    | '/profile'
    | '/register'
    | '/reset-password'
    | '/shipping'
    | '/verify-email'
    | '/watchlist'
    | '/auctions/$vehicleId'
    | '/vehicles/$vehicleId'
    | '/auctions'
    | '/vehicles'
  id:
    | '__root__'
    | '/'
    | '/bids'
    | '/compare'
    | '/contact'
    | '/dashboard'
    | '/faq'
    | '/forgot-password'
    | '/how-it-works'
    | '/login'
    | '/notifications'
    | '/payments'
    | '/pricing'
    | '/profile'
    | '/register'
    | '/reset-password'
    | '/shipping'
    | '/verify-email'
    | '/watchlist'
    | '/auctions/$vehicleId'
    | '/vehicles/$vehicleId'
    | '/auctions/'
    | '/vehicles/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BidsRoute: typeof BidsRoute
  CompareRoute: typeof CompareRoute
  ContactRoute: typeof ContactRoute
  DashboardRoute: typeof DashboardRoute
  FaqRoute: typeof FaqRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  HowItWorksRoute: typeof HowItWorksRoute
  LoginRoute: typeof LoginRoute
  NotificationsRoute: typeof NotificationsRoute
  PaymentsRoute: typeof PaymentsRoute
  PricingRoute: typeof PricingRoute
  ProfileRoute: typeof ProfileRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  ShippingRoute: typeof ShippingRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  WatchlistRoute: typeof WatchlistRoute
  AuctionsVehicleIdRoute: typeof AuctionsVehicleIdRoute
  VehiclesVehicleIdRoute: typeof VehiclesVehicleIdRoute
  AuctionsIndexRoute: typeof AuctionsIndexRoute
  VehiclesIndexRoute: typeof VehiclesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bids': {
      id: '/bids'
      path: '/bids'
      fullPath: '/bids'
      preLoaderRoute: typeof BidsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare': {
      id: '/compare'
      path: '/compare'
      fullPath: '/compare'
      preLoaderRoute: typeof CompareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/how-it-works': {
      id: '/how-it-works'
      path: '/how-it-works'
      fullPath: '/how-it-works'
      preLoaderRoute: typeof HowItWorksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/notifications': {
      id: '/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof NotificationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments': {
      id: '/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof PaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/shipping': {
      id: '/shipping'
      path: '/shipping'
      fullPath: '/shipping'
      preLoaderRoute: typeof ShippingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/watchlist': {
      id: '/watchlist'
      path: '/watchlist'
      fullPath: '/watchlist'
      preLoaderRoute: typeof WatchlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auctions/': {
      id: '/auctions/'
      path: '/auctions'
      fullPath: '/auctions/'
      preLoaderRoute: typeof AuctionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auctions/$vehicleId': {
      id: '/auctions/$vehicleId'
      path: '/auctions/$vehicleId'
      fullPath: '/auctions/$vehicleId'
      preLoaderRoute: typeof AuctionsVehicleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vehicles/': {
      id: '/vehicles/'
      path: '/vehicles'
      fullPath: '/vehicles/'
      preLoaderRoute: typeof VehiclesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/vehicles/$vehicleId': {
      id: '/vehicles/$vehicleId'
      path: '/vehicles/$vehicleId'
      fullPath: '/vehicles/$vehicleId'
      preLoaderRoute: typeof VehiclesVehicleIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BidsRoute: BidsRoute,
  CompareRoute: CompareRoute,
  ContactRoute: ContactRoute,
  DashboardRoute: DashboardRoute,
  FaqRoute: FaqRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  HowItWorksRoute: HowItWorksRoute,
  LoginRoute: LoginRoute,
  NotificationsRoute: NotificationsRoute,
  PaymentsRoute: PaymentsRoute,
  PricingRoute: PricingRoute,
  ProfileRoute: ProfileRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  ShippingRoute: ShippingRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  WatchlistRoute: WatchlistRoute,
  AuctionsVehicleIdRoute: AuctionsVehicleIdRoute,
  VehiclesVehicleIdRoute: VehiclesVehicleIdRoute,
  AuctionsIndexRoute: AuctionsIndexRoute,
  VehiclesIndexRoute: VehiclesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
